import React from 'react';
import * as Yup from 'yup';
import Popup from 'reactjs-popup';
import Modal from '../common/Modal/index';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import api from '../../service/api';
import { addCommonFormikErrorsIfEmpty, errorsTransformAxiosToFormik } from '../../util/error';
import SpinnerLoading from '../common/SpinnerLoading';

class ModalInviteCompanies extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    companyType: PropTypes.string.isRequired,
    emailBody: PropTypes.string,
  };

  static defaultProps = {
    emailBody:
      'We are using the Importist application for our product sourcing process as we believe it creates a seamless process for both suppliers and buyers.' +
      ' We would love for you to create an account to make the communication and quoting process between our teams easier.',
  };

  render() {
    return (
      <Modal>
        <Popup
          className="popup-invite-users"
          open={true}
          onClose={this.props.onClose}
          modal
          contentStyle={{ padding: '50px' }}
        >
          <div>
            <label className="form-header">
              Invite your {this.props.companyType === 'client' ? 'suppliers' : 'clients'} to use{' '}
              <span className="blue-color">Importist</span>!
            </label>
            <div className="row">
              <div className="form-group col-sm-6">
                <label>Choose your recipients</label>
                <div className="description">
                  You can add multiple email addresses. Please separate email addresses with a comma
                  (,).
                </div>
              </div>
            </div>
            <Formik
              initialValues={{
                emails: [],
                body: this.props.emailBody,
              }}
              validationSchema={Yup.object().shape({
                emails: Yup.array()
                  .required('Type at least one email address')
                  .of(Yup.string().email('One or more email address is not valid')),
                body: Yup.string().required('Message is required'),
              })}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                api
                  .companyEmailInvites(values.emails, values.body)
                  .then(() => {
                    setSubmitting(false);
                    this.props.onClose();
                  })
                  .catch((err) => {
                    setSubmitting(false);
                    const errors = errorsTransformAxiosToFormik(err);
                    setErrors(addCommonFormikErrorsIfEmpty(errors));
                  });
              }}
              render={({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group col-sm-12">
                      <textarea
                        name="emails"
                        value={values.emails}
                        onChange={(event) => {
                          setFieldValue('emails', event.target.value.split(/[\s,]+/));
                        }}
                        onBlur={handleBlur}
                      />
                      {touched.emails && errors.emails && (
                        <label className="error">{errors.emails}</label>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group no-margin-bottom col-sm-6">
                      <label>Send a message with your invite.</label>
                      <div className="description">
                        We have provided a short optimized template to get you started
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-12">
                      <textarea
                        className="modal-email-body-textarea"
                        name="body"
                        value={values.body}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.body && errors.body && (
                        <label className="error">{errors.body}</label>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-12">
                      <button
                        className="btn float-right blue-button"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        Send Invite
                      </button>
                    </div>
                  </div>
                  {isSubmitting && <SpinnerLoading centered={true} />}
                </form>
              )}
            />
          </div>
        </Popup>
      </Modal>
    );
  }
}

export default ModalInviteCompanies;
